/* eslint-disable no-lonely-if */
/* eslint-disable no-else-return */
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
// Desde 'umi' y no '@umijs/max': ver el comentario en src/utils/errorRedirect.ts.
// Este módulo lo cargan todos los servicios durante el arranque, así que con
// '@umijs/max' `history` llegaría sin asignar.
import { history } from 'umi';


import * as loginService from './services/login.service';
import { Token } from './interfaces/login';
import qs from 'qs';


let isRefreshing = false;
let refreshPromise: Promise<Token> | null = null;
let requestQueue: ((token: string) => void)[] = [];

export interface AxiosRequestCustomConfig  extends AxiosRequestConfig {
  skipAuth: boolean;
  // Si es true, un error 5xx no redirige a la pantalla /500 y se maneja en el llamador
  skipErrorPage?: boolean;
}

const request = axios.create({
  baseURL: API_URL,
  timeout: 60000,
  timeoutErrorMessage: 'Tiempo de espera agotado',
  paramsSerializer: (params) => {
    const filteredParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== null && value !== undefined && value !== ""
      )
    );
    return qs.stringify(filteredParams, { arrayFormat: "repeat", encode: false })
  },
  headers: {
    'Content-Type' : 'application/json',
  },
})


request.interceptors.request.use(async (config: AxiosRequestConfig) => {
  const customConfig = config as AxiosRequestCustomConfig;
  if (config.timeout) customConfig.timeout = config.timeout
  // Si tiene skipAuth, no se añade token
  if (customConfig.skipAuth) {
    return config;
  }

  let token = loginService.getToken();

  if (!token) {
    loginService.outLogin();
    window.location.href = '/ingresar';
    return Promise.reject('Sin token');
  }

  // Token no válido
  if (!loginService.isValid()) {
    if (!loginService.isRefreshValid()) {
      loginService.outLogin();
      window.location.href = '/ingresar';
      return Promise.reject('Refresh token expirado');
    }

    if (!isRefreshing) {
      isRefreshing = true;

      refreshPromise = loginService.refresh()
        .then((newToken: Token) => {
          loginService.setToken(newToken); // opcional, si no lo hace el refresh()
          requestQueue.forEach(cb => cb(newToken.access));
          requestQueue = [];
          return newToken;
        })
        .catch(err => {
          requestQueue = [];
          loginService.outLogin();
          window.location.href = '/ingresar';
          throw err;
        })
        .finally(() => {
          isRefreshing = false;
        });
    }

    // Esperar a que termine el refresh
    return new Promise((resolve) => {
      requestQueue.push((newToken: string) => {
        customConfig.headers = {
          ...customConfig.headers,
          Authorization: `Bearer ${newToken}`,
        };
        resolve(customConfig);
      });
    });
  }

  // Token válido
  customConfig.headers = {
    ...customConfig.headers,
    Authorization: `Bearer ${token}`,
  };

  return customConfig;
});


// Errores del backend: ante un 5xx mostramos la pantalla propia de error.
// El error se sigue rechazando para no alterar los catch existentes.
request.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const status = error.response?.status;
    const config = error.config as AxiosRequestCustomConfig | undefined;

    if (
      status &&
      status >= 500 &&
      !config?.skipErrorPage &&
      history.location.pathname !== '/500'
    ) {
      history.push('/500');
    }

    return Promise.reject(error);
  },
);


export default request;